/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_File_Exam_NoteInputs */

const da_forside_file_exam_note = /** @type {(inputs: Forside_File_Exam_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den fiktive prøve, 30 point`)
};

/** @type {(inputs: Forside_File_Exam_NoteInputs) => LocalizedString} */
const en_forside_file_exam_note = da_forside_file_exam_note;

/**

* @param {Forside_File_Exam_NoteInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_file_exam_note = /** @type {((inputs?: Forside_File_Exam_NoteInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_File_Exam_NoteInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_file_exam_note(inputs)
	return /** @type {LocalizedString} */ ("Den fiktive prøve, 30 point")
});